import { articleMetaBySlug } from "./meta";

export const meta = articleMetaBySlug["mental-fatigue"]!;

export function Body() {
  return (
    <>
      <p>
        After a long day of meetings or studying, a run can feel much harder than it should.
        Is that just in your head? A study from 2009 measured it.
      </p>

      <h2>What the researchers did</h2>
      <p>
        Sixteen people cycled to exhaustion at a hard, fixed effort on two occasions. Before
        one ride, they spent 90 minutes on a demanding mental task. Before the other, they spent
        90 minutes watching neutral documentaries.
      </p>

      <h2>What they found</h2>
      <p>
        After the mental task, they gave up about 15 percent sooner: after 640 seconds on
        average, against 754 seconds after the documentaries.
      </p>
      <p>
        Their heart, lungs and muscles responded in the same way in both rides, and they were
        just as motivated. The difference was that the effort felt harder from the start, so
        they reached their limit earlier.
      </p>

      <h2>What it means for you</h2>
      <p>
        A run that feels harder after a demanding day doesn't mean you have lost fitness. Your
        body can do the same, but it feels harder. On those days, it can be wise to keep a hard
        session controlled, run it at a time of day when you are fresher, or swap it for an easy
        run.
      </p>
      <p>
        It also means that how a session feels is useful information, but it is affected by more
        than your legs.
      </p>

      <h2>What the study can't tell you</h2>
      <p>
        The study was small, used cycling and tested one hard effort to exhaustion. It doesn't
        show how much mental fatigue affects an easy run or a long race.
      </p>

      <h2>How we use it</h2>
      <p>
        PX7 Training asks how you feel before a session and how hard it felt afterwards. A busy
        day counts, and the next sessions take it into account.
      </p>

      <h2>Source</h2>
      <ul>
        <li>
          Marcora, Staiano & Manning (2009), Mental fatigue impairs physical performance in
          humans.{" "}
          <a href="https://doi.org/10.1152/japplphysiol.91324.2008">Journal of Applied Physiology</a>.
        </li>
      </ul>
    </>
  );
}
